import { BRAND_NAME, URLS } from "@constants";
import { useTranslation } from "react-i18next";
import { BUTTON_IDS } from "@utils/GTM/buttonIds";

export interface ILink {
    id: string;
    route: string;
    title: string;
    showNewBadge?: boolean;
}

export const useNavigationLinks = (): ILink[] => {
    const { t } = useTranslation("header");

    return [
        {
            id: BUTTON_IDS.TOP_NAV.GO_MOBILE,
            route: URLS.MOBILE_ESHOP_URL,
            title: t("goMobile"),
        },
        {
            id: BUTTON_IDS.TOP_NAV.GO_BROADBAND,
            route: URLS.BROADBAND_ESHOP_URL,
            title: t("goBroadband"),
            showNewBadge: true,
        },
        {
            id: BUTTON_IDS.TOP_NAV.ABOUT_GOMO,
            route: URLS.ABOUT_URL,
            title: t("about", { brand: BRAND_NAME }),
        },
        {
            id: BUTTON_IDS.TOP_NAV.NEED_HELP,
            route: URLS.HELP_SUPPORT_URL,
            title: t("helpSupport"),
        },
    ];
};
